import React, {useCallback, useEffect, useRef, useState} from "react";
import styled, { css } from 'styled-components';
import 'react-dropdown/style.css';
import Button from "../Shared/Button";
import {
    setIsEditSubscriptionEmail,
    setIsSubscriptionEmailError,
    setIsSubscriptionEmailValid,
    setUpdatedSubscriptionEmail,
    updateEmailAddress,
    setUserPreferencesData,
    setIsEditMobileMode,
    setUpdatedMobileNumber,
    updatePhoneNumber,
    savePhoneNumber,
    setIsEmailNotOnFileError,
    setDailyPricesInvOption,
    setMonthlyPerformanceInvOption,
    setSelectedPricesServiceProducts,
    setSelectedPerformanceServiceProducts,
    setIsDailyPricesInvestmentError,
    setIsMonthlyPerformanceInvestmentError,
    setAddConsentRequestData,
    setServiceStatusMonthlyPerformanceRequestData,
    setServiceStatusDailyPricesRequestData,
    setSaveDailyPricesInvestmentOptions,
    setSaveMonthlyPerformanceInvestmentOptions,
    setPutServiceCallForDailyPrices,
    setPutServiceCallForMonthlyPerformance,
    setDeleteServiceCallForMonthlyPerformance,
    setDeleteServiceCallForDailyPrices,
    setSaveDailyPricesPreferences,
    setSaveMonthlyPerformancePreferences,
    setServiceProductDailPricesRequestData,
    setServiceProductMonthlyPerformanceData,
    savePreferencesAndSubscriptions, setIsSignUpForTextAlerts, setIsUpdatePhoneNumberLoaded, setIsSavePhoneNumberLoaded,
} from "../../redux/profile/slice";
import {UseAppDispatch, UseAppSelector} from "../../redux/configure-store";
import {
    ProfileBeaconButton,
    ProfileBeaconCheckbox,
    ProfileBeaconError,
    ProfileBeaconPopover
} from "../Shared/ProfileBeaconComponents";
import Input from "../Shared/Input";
import {
    getDailyPrices,
    getIsEditSubscriptionEmail,
    getIsPlanNonQualified,
    getIsSubscriptionEmailError,
    getIsSubscriptionEmailValid,
    getMonthlyPerformance,
    getOnlineStatements,
    getPaperlessPlanFeeDisclosures,
    getPaperlessPlanLegalNotices,
    getPaperlessProxyStatement,
    getPaperlessStatement,
    getParticipantConsentData,
    getSelectedPlan,
    getTracPlan,
    getUpdatedSubscriptionEmail,
    getUserPreferencesData,
    getEmailAddress,
    getEmailDeliveryStatus,
    getMobileNumber,
    getUpdatedMobileNumber,
    getIsEditMobileMode,
    isMobileNumberValid,
    getShowSignUpForTextAlertsButton,
    getIsShowToggleButton,
    getIsEmailNotOnFileError,
    getServiceStatus,
    getDailyPricesInvOption,
    getMonthlyPerformanceInvOption,
    getSelectedPricesServiceProducts,
    getSelectedPerformanceServiceProducts,
    getIsDailyPricesInvestmentError,
    getIsMonthlyPerformanceInvestmentError,
    getIsShowSaveModal,
    getRefreshPreferencesAndSubscriptions,
    getIsUpdatePhoneNumberLoaded,
    getIsSavePhoneNumberLoaded,
    getIsParticipantTerminated, getIsSempraActivePlanNameOlaMsg, getIsSempraTerminatedPlanNameOlaMsg, getIsSempraPlan
} from "../../redux/profile/selectors";
import {
    ProfileBeaconTable,
    ProfileBeaconTableHeader,
    ProfileBeaconTableRecord
} from '../Shared/ProfileBeaconComponents';
import {ProfileBeaconRadioButton} from "../Shared/ProfileBeaconComponents";
import Dropdown from "../Shared/Dropdown";
import {modalActions, profileActions} from "../../redux/root-action";
import {modals} from "../../utils/constants";
import ToggleSwitch from "../Shared/ToggleSwitch";
import Popover from "../Shared/Popover";
import {useHistory} from "react-router-dom";
import { isInternal } from "../../utils/api";
const StyledProfileInfo = styled.div`
  margin-top: 24px;
  padding: 56px 64px;
  background-color: #fff;
  @media (max-width: 768px) {
    padding: 48px 32px;
  }
  @media (max-width: 640px) {
    padding: 32px 24px;
  }
`;

const StyledTextSection = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
`;

const StyledTextHeader = styled.div`
  font-size: 40px;
  line-height: 1.2;
  letter-spacing: 0.05px;
  padding-bottom: 16px;
  @media (max-width: 768px) {
    font-size: 36px;
  }
  @media (max-width: 640px) {
    font-size: 24px;
  }
`;

const StyledTextContent = styled.div`
  font-size: 20px;
  line-height: 1.4;
  letter-spacing: 0.02px;
  padding-top:8px;
  padding-bottom: 16px;
  @media (max-width: 640px) {
    font-size: 16px;
    padding-bottom: 24px;
  }
`;

const StyledSubscriptionContent = styled.div`
  font-size: 20px;
  line-height: 1.4;
  letter-spacing: 0.02px;
  padding-top:8px;
  padding-bottom: 16px;
  @media(max-width: 1024px){
    font-size: 18px;
    padding-bottom: 0px;
  }
  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const StyledTextAlertContent = styled.div`
  background-color: #f9fafa;
  font-size: 18px;
  padding: 24px 40px;
  @media (max-width: 768px) {
    font-size: 16px;
    padding: 24px;
  }
  @media (max-width: 640px) {
    padding: 16px;
    display: inherit;
  }
`;

const StyledTextMobileContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 640px) {
    display: unset;
  }
  
`;

const StyledTextLabel = styled.span`
`;
const StyledTextMobileLabel = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 640px) {
    flex-direction: column;
    display: unset;
  }
`;

const StyledPhoneNumber = styled.span`
  font-weight: var(--beacon-font-weight-bold);
  margin-left: 5px;
`;
const StyledPhoneNumberContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: end;
  margin-left: 16px;
  @media (max-width: 640px) {
    flex-direction: column;
    width: 100%;
    margin-left: 0;
    margin-top: 8px;
  }
  
`;

const StyledPhoneButton = styled.div`
  margin-left: 8px;
  @media (max-width: 640px) {
    margin-left: 0;
    margin-top: 20px;
  }
  
  `;

const StyledValueContainer = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: var(--beacon-font-weight-bold);
  display: flex;
  align-items: center;
  margin-left: 16px;
  @media (max-width: 640px) {
    margin-left: 0;
    margin-top: 20px;
    justify-content: center;
  }
`;

const StyledEmail = styled.span`
  font-weight: var(--beacon-font-weight-bold);
  color: #3b4b59;
  padding-right: 16px;
  @media (max-width: 1024px) {
    word-break: break-word;
  }
`;

const StyledLinkContainer = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: var(--beacon-font-weight-bold);
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 640px) {
    margin-top: 12px;
  }
  
`;


const StyledSignUpButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
`;

const StyledLinkButton = styled.div`
  margin-right: 16px;
  @media(max-width: 640px){
    margin: 0;
  }
`;

const StyledTextAlertsContainer = styled.div`
  margin-top: 40px;
  margin-bottom: 50px;
  @media (max-width: 540px) {
    margin-top: 32px;
    margin-bottom: 50px;
  }
`;
const StyledTextAlertsHeader = styled.div`
  font-weight: var(--beacon-font-weight-bold);
  font-size: 24px;
  @media (max-width: 768px) {
    font-size: 20px;
  }
  @media (max-width: 540px) {
    font-size: 16px;
  }
`;

const StyledHeader = styled.div`
  font-weight: var(--beacon-font-weight-bold);
  font-size: 24px;
  @media (max-width: 768px) {
    font-size: 20px;
  }
  @media (max-width: 640px) {
    font-size: 18px;
  }
`;

const StyledTextAlertsSubHeaderListContainer = styled.div`
  font-size: 18px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;
const StyledTextAlertsTitleContainer = styled.div`
    padding: 14px 0;
    display: flex;
    justify-content: space-between;
    width: 350px;
    border-bottom: solid 1px #e9ebed;
  :last-child {
    border-bottom: none;
  }
  @media (max-width: 640px) {
    width: auto;
  }
`;

const StyledValue = styled.div`
`;

const StyledEmailAlertContent = styled.div`
  display: flex;
  align-items: center;
  background-color: #f9fafa;
  font-size: 18px;
  padding: 26px 40px 22px 40px;
  line-height: 1.33;
  letter-spacing: 0.02px;
  flex-wrap: wrap;
  row-gap: 13px;
  @media (max-width: 1024px) {
    padding: 24px;
    font-size: 16px;
    align-items: flex-start;
  }
   @media (max-width: 540px) {
   display:flex;
    justify-content:start;
    align-items:center;
    padding: 16px;
  }
`;

const StyledEmailContainer = styled.div`
  display: flex;
  align-items:center;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 12px;
  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const StyledInputContainer = styled.div`
  display: flex;
  align-items:center;
  @media(max-width: 640px){
    padding-top: 10px;
    padding-bottom: 18px;
    flex-direction: column;
    row-gap: 20px;
    width: 100%;
  }
`;

const StyledEmailLabel = styled.div.attrs((props: {isEmailError: boolean}) => props)`
  padding-right: 16px;
  padding-top: ${(props) => props.isEmailError && "34px"};
   @media (max-width: 768px) {
   padding-right: 8px;
   padding-top: 0;
  }
  @media (max-width: 540px) {
   display:flex;
   flex-direction:column;
    padding-top: ${(props) => props.isEmailError && "8px"};
  }
`;

const StyledButton = styled.div.attrs((props: {isEmailError: boolean}) => props)`
  padding-left: 8px;
  padding-top: ${(props) => props.isEmailError && "34px"};
  @media (max-width: 768px){
    padding-top: ${(props) => props.isEmailError && "30px"};
  }
  @media (max-width: 640px){
    padding-top: 0;
  }
`;

const StyledEditButton = styled.div`
  @media (max-width: 768px){
    margin-left:10px;
    };
  @media (max-width: 640px){
    margin-left:0;
  }
`;

const StyledPaperLessOptionsContainer =  styled.div`
  margin-top:40px;
  margin-bottom:40px;
  @media(max-width: 640px){
    margin: 32px 0;
  }
`;

const StyledTable = styled(ProfileBeaconTable)`
  margin-top: 24px;
  max-width: 961px;
  margin-bottom: 24px;
  border-style:none !important;
  --beacon-custom-table-container-overflow-x: unset !important;
  table{
    border-style:none !important;
  }
  tbody td {
    padding:0 !important;
    border-style: none;
  }
  tr th{
    background-color: #e9ebed !important;
    border-style:none !important;
    text-align: center !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 10px !important;
    padding-bottom:6px !important;
  }
  thead th{
    background-color: #f9fafa !important;
    border-style:none !important;
    padding-top: 24px !important;
    padding-bottom:20px !important;
    padding-left: 0 !important;
    padding-right:0 !important; 
    @media(max-width: 1024px){
      padding-top: 20px !important;
      padding-bottom: 16px !important;
    }
    @media(max-width: 640px){
      padding-top: 10px !important;
      padding-bottom: 8px !important;
    }
  }
  
  tr.no-bottom-border td {
    border-bottom: none !important
}

tr th.headerCenter {
   text-align: center !important;
   border-left: solid 1px #d3d7da !important;
   @media(max-width: 1024px){
     width: 260px;
   }
   @media(max-width: 640px){
     width: 142px;
   }
 }
 
tr th.headerLeft {
   text-align: left !important;
   padding-left: 24px !important;
   @media(max-width: 640px){
     padding-left: 16px !important;
   }
 }
 
tr th.header-center-with-border{
    text-align: center !important;
    border-left: solid 1px #d3d7da !important;
    border-right: solid 1px #d3d7da !important;   
    @media(max-width: 640px){
      padding: 12px 0px !important;
    }
 }
 
 tr td.apply-border-td{
    border-right: 1px solid #d3d7da !important;
    border-left: 1px solid #d3d7da !important;
 }

tr td.align-data-left{
  font-family: Nimbus Sans Novus !important;
  font-size: 18px !important;
  font-weight: normal !important;
  text-align:center !important;
  padding-left:24px !important; 
  @media(max-width: 1024px){
    padding-left: 16px !important;
  }
  @media(max-width: 640px){
    padding-left: 7px !important;
  }
}
  //--beacon-custom-table-container-block-size: 70vh; /* We use 80vh as an example but this could be any fixed height */
  --beacon-custom-table-container-overflow-x: auto;
  @media(max-width: 1024px){
    width: 100%;
    margin: 0;
  }
`;

const StyledTableHeader = styled(ProfileBeaconTableHeader).attrs((props: {isSubHeader: boolean}) => props)`
     font-family: Nimbus Sans Novus;
     font-size: 18px;
     font-weight: bold;
     font-stretch: normal;
     font-style: normal;  
    --beacon-cell-space-padding: 0;
    --text-cell-padding-inline-start: 0;
    --beacon-table-header-1st-cell-space-padding-inline-start:0;
    --text-cell-padding-block-start:0;
    --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
    --beacon-table-header-last-cell-space-padding-inline:0;
    --beacon-table-header-nth-cell-space-padding-inline-end:0;
    --beacon-table-header-nth-cell-space-padding-inline-start:0;
    @media(max-width: 768px){
      font-size: 16px;
    }
    @media(max-width: 640px){
      font-size: ${({isSubHeader}) => isSubHeader ? "12px" : "14px"};
    }
`;

const StyledColumnRecord = styled(ProfileBeaconTableRecord)`
  cursor: pointer;
  color: #086ea1;
  font-size: 16px;
  font-weight: bold;
  padding-top:10px !important;
  padding-bottom:15px !important;
  text-align: center;
  --beacon-table-record-space-margin-inline-start-default: 0;
  -beacon-unit-subatomic: 0;
  --beacon-cell-space-padding:0;
  --text-cell-padding-inline-start: 0;
  --beacon-table-header-1st-cell-space-padding-inline-start:0;
  --text-cell-padding-block-start:0;
  --beacon-table-header-nth-cell-space-padding-block-start-normal:0;
  --beacon-table-header-last-cell-space-padding-inline:0;
  @media(max-width: 1024px){
    padding-bottom: 8px !important;
    padding-top: 4px !important;
  }
  @media(max-width: 640px){
    padding-bottom: 10px !important;
    padding-top: 14px !important;
  }
`;

const StyledSelectButton = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledRadioButton = styled(ProfileBeaconRadioButton)`
  --beacon-form-font-size: 0px;
  @media(max-width: 640px){
    width: 28px;
  }
`;

const StyledCheckboxContainer = styled.div`
  display: inline-block;
  border-bottom: solid 1px #e9ebed;
  width:100%;
  padding-top: 22px;
  padding-bottom: 15px;
  @media (max-width: 768px) {
    --beacon-form-label-font-size: 16px;
  }
  @media (max-width: 640px) {
    --beacon-form-label-font-size: 16px;
  }
`;

const StyledCheckbox = styled(ProfileBeaconCheckbox)`
  --beacon-form-label-font-size: 18px;
  font-family: Nimbus Sans Novus;
  font-size: 18px;
  font-weight: bold;
  @media (max-width: 768px) {
    --beacon-form-label-font-size: 16px;
  }
  @media(max-width: 640px){
    --beacon-form-label-font-size: 14px;
  }
`;

const StyledCheckboxDescription = styled.div`
 margin: 6px 0 0px 40px;
  font-family: Nimbus Sans Novus;
  font-size: 18px;
  font-weight: normal;
  @media(max-width: 1024px){
    font-size: 16px;
  }
  @media(max-width: 640px){
    font-size: 14px;
  }
`;

const StyledDropdownContainer = styled.div`
  padding: 14px 0;
  display: flex;
  justify-content: flex-start;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.02px;
  text-align: left;
  color: #3b4b59;
  @media (max-width: 768px) {
    align-items: center;
    font-size: 16px;
    padding-top: 9px;
    padding-bottom: 7px;
    line-height: 1.5;
  }
  @media(max-width: 640px){
    padding-top: 16px;
    padding-bottom: 8px;
    width: auto !important;
    flex-direction: column;
  }
`;

const StyledUpdateInvestmentButton = styled.div`
    margin-left:16px;
    padding-top:14px;
  @media(max-width: 768px){
    margin-left: 14px;
    padding-top: 5px;
  }
  @media(max-width: 640px){
    margin-left: 0px;
    padding-top: 30px;
    padding-bottom: 10px;
    width:100%;
  }
`;

const StyledButtonContainer = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media(max-width: 640px){
    flex-direction: column-reverse;
    row-gap: 20px;
    margin-top: 32px;
    margin-bottom: 10px;
  }
`;

const StyledDisclaimerContainer = styled.div.attrs((props: {isInvestmentError: boolean}) => props)`
  padding: ${(props) => props.isInvestmentError ? "16px 24px" : "24px"};
  margin-top: 16px;
  border-radius: 4px;
  border: solid 1px #dd3636;
  background-color: rgba(221, 54, 54, 0.08);
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  letter-spacing: 0.02px;
  @media (max-width: 640px) {
    padding: ${(props) => props.isInvestmentError ? "16px" : "24px 16px"}
  }
`;

const StyledDisclaimerHeader = styled.div`
  font-size: 20px;
  font-weight: var(--beacon-font-weight-bold);
  text-align: left;
  line-height: 1.2;
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const StyledDisclaimerContent = styled.div.attrs((props: {isInvestmentError: boolean}) => props)`
  font-size: 18px;
  padding-top: ${(props) => props.isInvestmentError ? "0" : "8px"};
  line-height: 1.33;
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.5;
  }
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const StyledErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media(max-width: 640px){
    width: 100%;
  }
`;

export const PreferencesAndSubscriptionsCard = () => {
    const dispatch = UseAppDispatch();
    const { goBack } = useHistory();
    const emailAddressRef = useRef();
    const getStatus = (participantConsent: any, type : string) => {
        return Boolean(participantConsent?.find((consent: any)=> consent.consentType === type)?.consentIndicator);
    }

    const getSempraActiveStatus = (participantConsent: any, type : string) => {
      const consentType =  (participantConsent?.find((consent: any)=> consent.consentType === type)?.consentIndicator);
      if(consentType === null || consentType === undefined)
          return true;
      return consentType;
    }

    const fetchUserPreferencesData = UseAppSelector(getUserPreferencesData);
    const selectedPlan = UseAppSelector(getSelectedPlan);
    const planNumber = selectedPlan.value;
    const emailRegex = /^[a-zA-Z0-9.-_]+@[a-zA-Z]+\.[a-zA-Z]{3,4}$/;
    const isEditSubscriptionEmail = UseAppSelector(getIsEditSubscriptionEmail);
    const subscriptionEmailAddress = UseAppSelector(getEmailAddress);
    const updatedSubscriptionEmail = UseAppSelector(getUpdatedSubscriptionEmail);
    const isSubscriptionEmailValid = UseAppSelector(getIsSubscriptionEmailValid);
    const isEmailError = UseAppSelector(getIsSubscriptionEmailError);
    const isEmailNotOnFileError = UseAppSelector(getIsEmailNotOnFileError);
    const isTerminatedUser = UseAppSelector(getIsParticipantTerminated);


    const profileAlertsConstant = "52";
    const transactionAlertConstant = "51";
    const statementsStatusConstant = "5";
    const eConfirmStatusConstant = "28";
    const disclosureStatusConstant = "33";
    const noticeStatusConstant = "35";
    const proxyNoticesStatusConstant = "34";
    const prospectusAndFormsEmployedConstant = "57";
    const prospectusAndFormsAfterEmploymentConstant = "58";
    const tipsResourcesStatusConstant = "25";
    const dailyPriceStatusConstant = "23";
    const monthlyPerformanceStatusConstant = "24";
    const withdrawalStatusConstant = "30";
    const dailyPricesServiceOptionCode = "20";
    const monthlyPerformanceServiceOptionCode = "21";
    const dailyPricesServiceOptionName = "Daily Price Emails";
    const monthlyPerformanceServiceoptionName = "Monthly Performance Emails";
    const commProcessCode = "    ";

    var date = new Date();

    // Get year, month, and day part from the date
    var year = date.toLocaleString("default", { year: "numeric" });
    var month = date.toLocaleString("default", { month: "2-digit" });
    var day = date.toLocaleString("default", { day: "2-digit" });

    // Generate yyyy-mm-dd date string
    var formattedDate = year + "-" + month + "-" + day;

    const onlineStatements = UseAppSelector(getOnlineStatements);
    const paperlessStatement = UseAppSelector(getPaperlessStatement);
    const tracPlan = UseAppSelector(getTracPlan);
    const paperlessPlanFeeDisclosures = UseAppSelector(getPaperlessPlanFeeDisclosures);
    const paperlessPlanLegalNotices = UseAppSelector(getPaperlessPlanLegalNotices);
    const paperlessProxyStatement = UseAppSelector(getPaperlessProxyStatement);
    const dailyPrices = UseAppSelector(getDailyPrices);
    const monthlyPerformance = UseAppSelector(getMonthlyPerformance);
    const isEmailUndeliverable = UseAppSelector(getEmailDeliveryStatus);
    const isPlanNonQualified = UseAppSelector(getIsPlanNonQualified);
    const participantConsents: any = UseAppSelector(getParticipantConsentData);
    const profileAlertStatus = getStatus(participantConsents, "52");
    const transactionalAlertStatus = getStatus(participantConsents, "51");
    const statementsStatus = getStatus(participantConsents, "5");
    const eConfirmStatus = getStatus(participantConsents, "28");
    const disclosureStatus = getStatus(participantConsents, "33");
    const noticeStatus = getStatus(participantConsents, "35");
    const proxyNoticesStatus = getStatus(participantConsents, "34");
    const prospectusAndFormsEmployedStatus = getSempraActiveStatus(participantConsents, "57");
    const prospectusAndFormsAfterEmploymentStatus = getStatus(participantConsents, "58");
    const tipsResourcesStatus = getStatus(participantConsents, "25");
    const dailyPriceStatus = getStatus(participantConsents, "23");
    const monthlyPerformanceStatus = getStatus(participantConsents, "24");
    const withdrawalStatus = getStatus(participantConsents, "30");
    const excludedPlanNumbers = ["999995","104600","105292","250919"];
    const showEConfirm = !excludedPlanNumbers.includes(planNumber) && !tracPlan;
    const isShowStatements = onlineStatements && paperlessStatement;
    const showProxyNotices = !tracPlan && paperlessProxyStatement;
    const isNoticeStatusActive = noticeStatus? false : true;
    const [statementsPaperLess, setStatementsPaperLess] = useState(statementsStatus);
    const [confirmationsPaperless,setConfirmationsPaperless] = useState(eConfirmStatus);
    const [disclosuresPaperless, setDisclosuresPaperless] = useState(disclosureStatus);
    const [noticesPaperless, setNoticesPaperless] = useState(isNoticeStatusActive);
    const [proxyPaperless, setProxyPaperless] = useState(proxyNoticesStatus);
    const [prospectusAndFormsEmployedPaperless, setProspectusAndFormsEmployedPaperless] = useState(prospectusAndFormsEmployedStatus);
    const [prospectusAndFormsAfterEmploymentPaperless, setProspectusAndFormsAfterEmploymentPaperless] = useState(prospectusAndFormsAfterEmploymentStatus);
    const [tipsAndResourceStatus, setTipsAndResourceStatus] = useState(tipsResourcesStatus);
    const [dailyPricesStatus, setDailyPricesStatus] = useState(dailyPriceStatus);
    const [monthlyPerformancesStatus, setMonthlyPerformancesStatus] = useState(monthlyPerformanceStatus);
    const [withdrawalsStatus, setWithdrawalsStatus] = useState(withdrawalStatus);
    const [emailSignUpTextAlertsError, setEmailSignUpTextAlertsError] = useState(false);

    const isDailyPricesInvestmentError = UseAppSelector(getIsDailyPricesInvestmentError);
    const isMonthlyPerformanceInvestmentError = UseAppSelector(getIsMonthlyPerformanceInvestmentError);
    const selectedPricesServiceProducts = UseAppSelector(getSelectedPricesServiceProducts);
    const selectedPerformanceServiceProducts = UseAppSelector(getSelectedPerformanceServiceProducts);
    const refreshPreferencesAndSubscriptions = UseAppSelector(getRefreshPreferencesAndSubscriptions);

    const mobileNumber = UseAppSelector(getMobileNumber);
    const updatedMobileNumber = UseAppSelector(getUpdatedMobileNumber);
    const isEditMobileMode = UseAppSelector(getIsEditMobileMode);
    const mobileNumberValid = UseAppSelector(isMobileNumberValid);
    const showSignUpForTextAlertsButton = UseAppSelector(getShowSignUpForTextAlertsButton);
    const isSignUpForTextAlerts = UseAppSelector(getIsShowToggleButton);

    const isTracPlan = UseAppSelector(getTracPlan);
    const isOmniPlan = !isPlanNonQualified && !isTracPlan;
    const [profileChangeAlerts, setProfileChangeAlerts] = useState(false);
    const [transactionAlerts, setTransactionAlerts] = useState(false);

    const isSempraPlan = UseAppSelector(getIsSempraPlan);
    const sempraActiveDeliveryOptionLabel = UseAppSelector(getIsSempraActivePlanNameOlaMsg);
    const sempraTerminatedDeliveryOptionLabel = UseAppSelector(getIsSempraTerminatedPlanNameOlaMsg);
    const showSempraActiveDeliveryOptionLabel = isSempraPlan && !isTerminatedUser && sempraActiveDeliveryOptionLabel && (sempraActiveDeliveryOptionLabel?.trim()!=="");
    const showSempraTerminatedDeliveryOptionLabel = isSempraPlan && sempraTerminatedDeliveryOptionLabel && (sempraTerminatedDeliveryOptionLabel?.trim()!=="")
    const planName = selectedPlan?.label?.type === 'a'? selectedPlan?.label?.props?.children : selectedPlan?.label;
    const sempraDeliveryOptionsPopOver = planName?.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) + "Prospectus incorporates the plan’s Summary Plan Description and Core Investment Funds & Operating Expense Summary. Form 10-K is an annual report that provides information about Sempra, including its organizational structure, financial statements, earnings per share, liquidity, and material risks.";

    useEffect(() => {
        if(showSignUpForTextAlertsButton) {
            setProfileChangeAlerts(profileAlertStatus);
            setTransactionAlerts(transactionalAlertStatus);
        }
    }, []);

    useEffect(() => {
        if(isSignUpForTextAlerts) {
            setProfileChangeAlerts(isSignUpForTextAlerts);
            setTransactionAlerts(isSignUpForTextAlerts);
            const tempUserActionObject = userActions;
            tempUserActionObject[profileAlertsConstant] = true;
            tempUserActionObject[transactionAlertConstant] = true;
            setUserActions({...tempUserActionObject});
            dispatch(setIsSignUpForTextAlerts(false));
        }

    }, [isSignUpForTextAlerts]);

    const [showEDeliveryModalState,setShowEDeliveryModalState] = useState({
        "5":  false,
        "28": false,
        "33": false,
        "35": false,
        "34": false,
        "57": false,
        "58": false,
    });

    const [userActions, setUserActions] = useState({
        "52": false,
        "51": false,
        "5": false,
        "28": false,
        "33": false,
        "35": false,
        "34": false,
        "23": false,
        "24": false,
        "25": false,
        "30": false,
        "57": false,
        "58": false
    })

    const servicesAndRequest:any ={};

    const selectedDailyPriceInvestmentOptions = UseAppSelector(getSelectedPricesServiceProducts);
    const selectedMonthlyPerInvOptions = UseAppSelector(getSelectedPerformanceServiceProducts);
    const isShowSaveModal = UseAppSelector(getIsShowSaveModal);
    const investmentOptions =
        [
            {name: "The Investment options that I invested in", value: "B", id: "option1"},
            {name: "All investment options available in my plan ", value: "C", id: "option2"},
            {name: "Select specific investment options in my plan", value: "G", id: "option3"}
        ]
    const serviceStatus = UseAppSelector(getServiceStatus);
    const getUpdatedDailyPriceInvOption = UseAppSelector(getDailyPricesInvOption);
    const getUpdatedMonthlyPerformanceOption = UseAppSelector(getMonthlyPerformanceInvOption);

    const dailyPriceServiceStatus = serviceStatus?.find((status: any) => status?.serviceOptionCode == 20);
    const defaultDailyPriceOption = dailyPriceServiceStatus ? investmentOptions.find((option: any) => option.value === dailyPriceServiceStatus?.serviceStatusCode)?.value : "B";
    const updatedDailyPriceInvOption = getUpdatedDailyPriceInvOption ? getUpdatedDailyPriceInvOption : defaultDailyPriceOption;

    const monthlyPerformanceServiceStatus = serviceStatus?.find((status: any) => status?.serviceOptionCode == 21);
    const monthlyPerformanceInvOption = monthlyPerformanceServiceStatus ? investmentOptions.find((option: any) => option.value === monthlyPerformanceServiceStatus?.serviceStatusCode)?.value : "B";
    const updatedMonthlyPerformanceOption = getUpdatedMonthlyPerformanceOption ? getUpdatedMonthlyPerformanceOption : monthlyPerformanceInvOption;

    const isUserChangedValues = ((defaultDailyPriceOption != updatedDailyPriceInvOption) ||
            (monthlyPerformanceInvOption != updatedMonthlyPerformanceOption) || selectedPricesServiceProducts.length > 0 || selectedPerformanceServiceProducts.length > 0 ||
            (statementsPaperLess !== statementsStatus) || (eConfirmStatus !== confirmationsPaperless) ||
            (disclosureStatus !== disclosuresPaperless) || (isNoticeStatusActive !== noticesPaperless) || (proxyNoticesStatus !== proxyPaperless) ||
            (prospectusAndFormsEmployedStatus != prospectusAndFormsEmployedPaperless) || (prospectusAndFormsAfterEmploymentStatus != prospectusAndFormsAfterEmploymentPaperless) ||
            (tipsAndResourceStatus != tipsResourcesStatus) || (dailyPricesStatus != dailyPriceStatus) || (monthlyPerformancesStatus != monthlyPerformanceStatus) ||
            (withdrawalsStatus != withdrawalStatus)) || (showSignUpForTextAlertsButton && (profileAlertStatus !==  profileChangeAlerts)) ||
        (showSignUpForTextAlertsButton && (transactionAlerts !== transactionalAlertStatus));

    const isSaveButtonEnabled =  !isEmailNotOnFileError && !isEmailUndeliverable &&
        ((isDailyPricesInvestmentError && updatedDailyPriceInvOption != "G" ||
        selectedPricesServiceProducts.length > 0) || !isDailyPricesInvestmentError) &&
        ((isMonthlyPerformanceInvestmentError && updatedMonthlyPerformanceOption != "G" ||
        selectedPerformanceServiceProducts.length > 0) || !isMonthlyPerformanceInvestmentError) && isUserChangedValues;

    const isDailyPricesSpecificInvestment = updatedDailyPriceInvOption === "G"? true: false;
    const [showUpdateInvestmentsDailyPrices, setShowUpdateInvestmentsDailyPrices] = useState(isDailyPricesSpecificInvestment);

    const isMonthlyPerformanceInvestmentSpecific =  updatedMonthlyPerformanceOption ==="G"? true: false;
    const [showUpdateInvestmentsMonthlyPerformance, setShowUpdateInvestmentsMonthlyPerformance] = useState(isMonthlyPerformanceInvestmentSpecific);
    const isUpdatePhoneNumberLoaded = UseAppSelector(getIsUpdatePhoneNumberLoaded);
    const isSavePhoneNumberLoaded = UseAppSelector(getIsSavePhoneNumberLoaded);
    const [isPhoneNumberChanged, setIsPhoneNumberChanged] = useState(false);

    const showSignUpAuthenticatedModal = useCallback(() => {
        dispatch(modalActions.showModal(modals.SIGN_UP_AUTHENTICATED_MODAL));
    }, [dispatch]);

    const showSignUpModal = useCallback(() => {
        dispatch(modalActions.showModal(modals.SIGN_UP_MODAL));
    }, [dispatch]);

    useEffect(() => {
        if (isUpdatePhoneNumberLoaded || isSavePhoneNumberLoaded) {
            dispatch(setIsUpdatePhoneNumberLoaded(false));
            dispatch(setIsSavePhoneNumberLoaded(false));
            if(isPhoneNumberChanged) {
                showSignUpForTextAlertsButton && showSignUpAuthenticatedModal();
                setProfileChangeAlerts(false);
                setTransactionAlerts(false);
            }
            !showSignUpForTextAlertsButton && showSignUpModal();
        }
    },[isPhoneNumberChanged, isUpdatePhoneNumberLoaded, isSavePhoneNumberLoaded]);

    const handleEditMobile = () => {
        dispatch(setIsEditMobileMode(true));
    }
    const handleMobileNumberChange = (event: any) => {
        dispatch(setUpdatedMobileNumber(event.target.value));
        if(event.target.value.length === 12) {
            dispatch(profileActions.setMobileNumberValid(true))
        } else {
            dispatch(profileActions.setMobileNumberValid(false))
        }
    }
    const saveMobileNumber = useCallback((updatedMobileNumber) => {
        if(mobileNumber != updatedMobileNumber)
            setIsPhoneNumberChanged(true);
        if(mobileNumber){
            dispatch(updatePhoneNumber({mobileNumber:updatedMobileNumber, planNumber}));
        }else{
            dispatch(savePhoneNumber({mobileNumber:updatedMobileNumber, planNumber}));
        }
    },[dispatch,mobileNumber]);

    const handleProfileChangeAlerts = () => {
        const tempUserActionObject = userActions;
        tempUserActionObject[profileAlertsConstant] = true;
        setProfileChangeAlerts(!profileChangeAlerts);
        setUserActions({...tempUserActionObject})
    };

    const handleTransactionAlerts = () => {
        const tempUserActionObject = userActions;
        tempUserActionObject[transactionAlertConstant] = true;
        setUserActions({...tempUserActionObject})
        setTransactionAlerts(!transactionAlerts);
    };

    const handleEditSubscriptionEmail = () => {
        dispatch(setIsEditSubscriptionEmail(true))
    }

    const handleSubscriptionEmailChange = (event: any) => {
        dispatch(setUpdatedSubscriptionEmail(event.target.value))
        if(emailRegex.test(event.target.value))
            dispatch(setIsSubscriptionEmailValid(true))
        else
            dispatch(setIsSubscriptionEmailValid(false))
    }

    const handleSubscriptionEmailValidation = (event: any) => {
        if (event.target.value !== "" && !emailRegex.test(event.target.value))
            dispatch(setIsSubscriptionEmailError(true))
        else
            dispatch(setIsSubscriptionEmailError(false))
    }

    useEffect(() => {
        if(isShowSaveModal)
            dispatchShowSaveModal();
    }, [isShowSaveModal]);

    useEffect(()=>{
        if(refreshPreferencesAndSubscriptions)
            window.location.reload();
    },[refreshPreferencesAndSubscriptions])

    const dispatchShowSaveModal = useCallback(() =>{
        dispatch(modalActions.showModal(modals.SAVED_MODAL));
    }, [dispatch]);

    const handleSelectAllPaperlessOptions =()=>{
        const consents = {}
        const tempObj = showEDeliveryModalState;
        const tempUserActionObject = userActions;
        if (isShowStatements) {
            consents["5"] = true
            tempObj["5"] = true
            setStatementsPaperLess(true)
        }
        if (showEConfirm) {
            consents["28"] = true
            tempObj["28"] = true
            setConfirmationsPaperless(true)
        }
        if (paperlessPlanFeeDisclosures) {
            consents["33"] = true
            tempObj["33"] = true
            setDisclosuresPaperless(true)
        }
        if (paperlessPlanLegalNotices) {
            consents["35"] = true
            tempObj["35"] = true
            setNoticesPaperless(true)
        }
        if (showProxyNotices) {
            consents["34"] = true
            tempObj["34"] = true
            setProxyPaperless(true)
        }
        if(showSempraActiveDeliveryOptionLabel){
            consents["57"] = true
            tempObj["57"] = true
            tempUserActionObject["57"] = true
            setProspectusAndFormsEmployedPaperless(true)
        }
        if(showSempraTerminatedDeliveryOptionLabel){
            consents["58"] = true
            tempObj["58"] = true
            tempUserActionObject["58"] = true
            setProspectusAndFormsAfterEmploymentPaperless(true)
        }
        setShowEDeliveryModalState({...tempObj});

        tempUserActionObject[statementsStatusConstant] = true;
        tempUserActionObject[eConfirmStatusConstant] = true;
        tempUserActionObject[disclosureStatusConstant] = true;
        tempUserActionObject[noticeStatusConstant] = true;
        tempUserActionObject[proxyNoticesStatusConstant] = true;
        setUserActions({...tempUserActionObject});

        dispatch(setUserPreferencesData({
            ...fetchUserPreferencesData, ...consents
        }));
    }
    const onPreferencesRadioChange = (type:string, value: boolean) => {
        const consents = { [type]: value };
        const participantConsents = {
            "5": setStatementsPaperLess,
            "28": setConfirmationsPaperless,
            "33": setDisclosuresPaperless,
            "35": setNoticesPaperless,
            "34": setProxyPaperless,
            "57": setProspectusAndFormsEmployedPaperless,
            "58": setProspectusAndFormsAfterEmploymentPaperless
        }
        const preferenceSetter = participantConsents[type];
        const tempObj = showEDeliveryModalState;
        const tempUserActionObject = userActions;
        tempObj[type]= value;
        tempUserActionObject[type] = true;
        setShowEDeliveryModalState({...tempObj});
        setUserActions({...tempUserActionObject})
        if (preferenceSetter) {
            preferenceSetter(value);
        }
        dispatch(setUserPreferencesData({
            ...fetchUserPreferencesData, ...consents
        }));

  }

    const onEmailSubscriptionChange =  (event: any, type:string) => {
        const value = event.target.checked;
        const tempUserActionObject = userActions;
        const consents = { [type]: value };
        const participantConsents = {
            "23": setDailyPricesStatus,
            "24": setMonthlyPerformancesStatus,
            "25": setTipsAndResourceStatus,
            "30": setWithdrawalsStatus
        }
        const preferenceSetter = participantConsents[type];
        if (preferenceSetter) {
            preferenceSetter(value);
        }
        tempUserActionObject[type] = true;
        setUserActions({...tempUserActionObject})
    }
    const dispatchDailyPricesInvestmentOptionsModal = useCallback(() =>{
        const tempUserActions = userActions;
        tempUserActions[dailyPriceStatusConstant] = true;
        setUserActions({...tempUserActions})
        dispatch(modalActions.showModal(modals.DAILY_PRICES_INVESTMENT_OPTIONS_MODAL));
    }, [dispatch]);

    const dispatchMonthlyPerformanceInvestmentModal = useCallback(() =>{
        const tempUserActions = userActions;
        tempUserActions[monthlyPerformanceStatusConstant] = true;
        setUserActions({...tempUserActions})
        dispatch(modalActions.showModal(modals.MONTHLY_PERFORMANCE_INVESTMENT_OPTIONS_MODAL));
    }, [dispatch]);

    const handleDailyPricesChange = useCallback((event: any) =>{
        const tempUserActions = userActions;
        tempUserActions[dailyPriceStatusConstant] = true;
        setUserActions({...tempUserActions})
        dispatch(setDailyPricesInvOption(event.target.value));
        if(event.target.value === "G"){
            setShowUpdateInvestmentsDailyPrices(true);
            dispatchDailyPricesInvestmentOptionsModal();
        }
        else
            setShowUpdateInvestmentsDailyPrices(false);
    }, [dispatch]);

    const handleMonthlyPerformanceChange = useCallback((event: any) =>{
        const tempUserActions = userActions;
        tempUserActions[monthlyPerformanceStatusConstant] = true;
        setUserActions({...tempUserActions})
        dispatch(setMonthlyPerformanceInvOption(event.target.value));
        if(event.target.value === "G"){
            setShowUpdateInvestmentsMonthlyPerformance(true);
            dispatchMonthlyPerformanceInvestmentModal();
        }
        else
            setShowUpdateInvestmentsMonthlyPerformance(false);
    }, [dispatch]);

    const cancelPreferences = useCallback(() => {
        dispatch(setDailyPricesInvOption(defaultDailyPriceOption));
        dispatch(setMonthlyPerformanceInvOption(monthlyPerformanceInvOption));
        dispatch(setSelectedPricesServiceProducts([]));
        dispatch(setSelectedPerformanceServiceProducts([]));
        goBack();
    }, [dispatch]);

    const showConfirmSaveModal = () => {
        //save user preferences and show confirm modal
        savePreferencesAndSubscription(false);
        dispatchConfirmSaveModal();
    }

    const dispatchConfirmSaveModal = useCallback(() => {
        dispatch(modalActions.showModal(modals.CONFIRM_SAVE_MODAL));
    }, [dispatch]);

    const showEDeliveryAgreementModal = useCallback(() => {
        dispatch(modalActions.showModal(modals.E_DELIVERY_AGREEMENT_MODAL));
    }, [dispatch]);

    const setEditSubscriptionAndEmailNotOnFileError = useCallback(() => {
        dispatch(setIsEditSubscriptionEmail(true))
        dispatch(setIsEmailNotOnFileError(true))
    }, [dispatch]);
    useEffect(() => {
        if (isEmailNotOnFileError) {
            emailAddressRef.current?.scrollIntoView({behavior: "smooth"});
        }
    }, [isEmailNotOnFileError]);
    useEffect(() => {
        if(isEmailNotOnFileError) {
            dispatch(setIsEditSubscriptionEmail(false))
            dispatch(setIsEmailNotOnFileError(false))
        }
    }, []);
    const validatePreferencesAndSubscription = () => {
        let isValid = true;
        if(!subscriptionEmailAddress.trim()) {
            setEditSubscriptionAndEmailNotOnFileError();
            emailAddressRef.current?.scrollIntoView({ behavior: "smooth" });
            isValid = false;
        }
        if(selectedPricesServiceProducts.length === 0 && isDailyPricesSpecificInvestment) {
            isValid = false;
            dispatch(setIsDailyPricesInvestmentError(true));
        }
        else {
            dispatch(setIsDailyPricesInvestmentError(false));
        }
        if(selectedPerformanceServiceProducts.length === 0 && isMonthlyPerformanceInvestmentSpecific) {
            isValid = false;
            dispatch(setIsMonthlyPerformanceInvestmentError(true));
        }
        else {
            dispatch(setIsMonthlyPerformanceInvestmentError(false));
        }
        if(isValid) {
            if(!Object.values(showEDeliveryModalState).includes(true)) {
                savePreferencesAndSubscription(true);
            } else {
                savePreferencesAndSubscription(false);
                showEDeliveryAgreementModal();
            }
        }
    }

    const resetUserActions = ()=>{
        const resetUserActionObj = {"52": false,
            "51": false,
            "5": false,
            "28": false,
            "33": false,
            "35": false,
            "34": false,
            "23": false,
            "24": false,
            "25": false,
            "30": false,
            "57": false,
            "58": false,
        }
        const resetModalState = { "5":  false,
            "28": false,
            "33": false,
            "35": false,
            "34": false,
            "57": false,
            "58": false
        };
        setUserActions({...resetUserActionObj})
        setShowEDeliveryModalState({...resetModalState})
    }

    function savePreferencesAndSubscription (isCallFromSave:boolean){
        const filteredUserActions = [];
        for (let [key, value] of Object.entries(userActions)) {
            if(value)
                filteredUserActions.push(key);
        }
        if(filteredUserActions.length>0){
            addConsentRequest(filteredUserActions, isCallFromSave);
                if (filteredUserActions.includes(dailyPriceStatusConstant) || filteredUserActions.includes(monthlyPerformanceStatusConstant)) {
                    makeServiceStatusCall(filteredUserActions, isCallFromSave);

                } else {
                    dispatch(setSaveDailyPricesPreferences(false))
                    dispatch(setSaveMonthlyPerformancePreferences(false))
                }
                if(isCallFromSave)
                    dispatchPreferencesAndSubscriptions(servicesAndRequest);
            resetUserActions();
        }
    }

    const addConsentRequest = (userActions, isCallFromSave:boolean)=>{
        const requestBody = userActions.map((value:String) => {
            const tempRequestObject = {
                "consentType": value,
                "consentIndicator":"",
                "userId": "IVROLA",
                "planNumber": planNumber,
                "orgUsrNu": "IVROLA"
            }
            switch (value) {
                case profileAlertsConstant:
                    if(profileChangeAlerts)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case transactionAlertConstant:
                    if(transactionAlerts)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case statementsStatusConstant:
                    if(statementsPaperLess)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case eConfirmStatusConstant:
                    if(confirmationsPaperless)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case disclosureStatusConstant:
                    if(disclosuresPaperless)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case noticeStatusConstant:
                    if(noticesPaperless)
                        tempRequestObject.consentIndicator = "N";
                    else
                        tempRequestObject.consentIndicator = "Y";
                    break;

                case proxyNoticesStatusConstant:
                    if(proxyPaperless)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case prospectusAndFormsEmployedConstant:
                    if(prospectusAndFormsEmployedPaperless)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case prospectusAndFormsAfterEmploymentConstant:
                    if(prospectusAndFormsAfterEmploymentPaperless)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case tipsResourcesStatusConstant:
                    if(tipsAndResourceStatus)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case dailyPriceStatusConstant:
                    if(dailyPricesStatus)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";

                    break;

                case monthlyPerformanceStatusConstant:
                    if(monthlyPerformancesStatus)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;

                case withdrawalStatusConstant:
                    if(withdrawalsStatus)
                        tempRequestObject.consentIndicator = "Y";
                    else
                        tempRequestObject.consentIndicator = "N";
                    break;
            }
            return tempRequestObject;
        })
        if(!isCallFromSave)
            dispatch(setAddConsentRequestData([...requestBody]));
        else{
            // dispatchPreferencesAndSubscriptionConsents(requestBody);
            servicesAndRequest.addConsents = requestBody;
        }

    }

    const makeServiceStatusCall = (userActions, isCallFromSave:boolean)=>{
        if(userActions.includes(dailyPriceStatusConstant))
        {
            serviceStatusCallForDailyPrices(isCallFromSave);
        }
        else
            dispatch(setSaveDailyPricesPreferences(false))
        if(userActions.includes(monthlyPerformanceStatusConstant))
        {
            serviceStatusCallForMonthlyPerformance(isCallFromSave);
        }
        else
            dispatch(setSaveMonthlyPerformancePreferences(false))
    }

    const serviceStatusCallForDailyPrices = (isCallFromSave:boolean)=>{
        if(dailyPricesStatus){
            //call PUT service-status for Daily Prices
            const reqObject = {
                "serviceOptionCode": dailyPricesServiceOptionCode,
                "planNumber": planNumber,
                "serviceOptionName": dailyPricesServiceOptionName,
                "serviceStatusCode": updatedDailyPriceInvOption,
                "commProcessCode": commProcessCode,
                "serviceEnrollDate": formattedDate
            }
            if(!isCallFromSave){
                dispatch(setSaveDailyPricesPreferences(true))
                dispatch(setPutServiceCallForDailyPrices(true));
                dispatch(setDeleteServiceCallForDailyPrices(false))
                dispatch(setServiceStatusDailyPricesRequestData(reqObject))
            }
            else{
                // dispatchPutDailyPricesOrMonthlyPerformance(reqObject)
                servicesAndRequest.updateServiceStatusDaily = reqObject;
            }

            if(updatedDailyPriceInvOption === "G"){
                //Update Investment Options for Daily Prices
                const investOptionRequest = {
                    "serviceOptionCode": parseInt(dailyPricesServiceOptionCode),
                    "planNumber": planNumber,
                    "productCodes": selectedDailyPriceInvestmentOptions,
                }
                if(!isCallFromSave){
                    dispatch(setServiceProductDailPricesRequestData(investOptionRequest));
                    dispatch(setSaveDailyPricesInvestmentOptions(true))
                }
                else{
                    servicesAndRequest.updateServiceProductsDaily = investOptionRequest;
                    // dispatchUpdateInvestmentOptions(investOptionRequest);
                }

            }
            else
                dispatch(setSaveDailyPricesInvestmentOptions(false))
        }
        else{
            //call DELETE service-status for Daily Prices
            const reqObj = {
                "serviceOptionCode": dailyPricesServiceOptionCode,
                "planNumber": planNumber,
            }
            if(!isCallFromSave){
                dispatch(setSaveDailyPricesPreferences(true))
                dispatch(setDeleteServiceCallForDailyPrices(true))
                dispatch(setPutServiceCallForDailyPrices(false));
                dispatch(setSaveDailyPricesInvestmentOptions(false))
                dispatch(setServiceStatusDailyPricesRequestData(reqObj))
            }
            else{
                //dispatchDeleteDailyPricesOrMonthlyPerformance(reqObj);
                servicesAndRequest.deleteServiceStatusDaily = reqObj;
            }
        }
    }

    const serviceStatusCallForMonthlyPerformance = (isCallFromSave:boolean)=>{
        if(monthlyPerformancesStatus){
            //call PUT service-status service Monthly Performance
            const reqObject = {
                "serviceOptionCode": monthlyPerformanceServiceOptionCode,
                "planNumber": planNumber,
                "serviceOptionName": monthlyPerformanceServiceoptionName,
                "serviceStatusCode": updatedMonthlyPerformanceOption,
                "commProcessCode": commProcessCode,
                "serviceEnrollDate": formattedDate
            }
            if(!isCallFromSave){
                dispatch(setPutServiceCallForMonthlyPerformance(true))
                dispatch(setServiceStatusMonthlyPerformanceRequestData(reqObject))
                dispatch(setSaveMonthlyPerformancePreferences(true))
                dispatch(setDeleteServiceCallForMonthlyPerformance(false))
            }
            else{
                // dispatchPutDailyPricesOrMonthlyPerformance(reqObject)
                servicesAndRequest.updateServiceStatusMonthly = reqObject;
            }
            if(updatedMonthlyPerformanceOption === "G"){
                //Update Investment Options for Monthly Performance
                const investOptionRequest = {
                    "serviceOptionCode": parseInt(monthlyPerformanceServiceOptionCode),
                    "planNumber": planNumber,
                    "productCodes": selectedMonthlyPerInvOptions,
                }
                if(!isCallFromSave){
                    dispatch(setSaveMonthlyPerformanceInvestmentOptions(true))
                    dispatch(setServiceProductMonthlyPerformanceData(investOptionRequest))
                }
                else{
                    // dispatchUpdateInvestmentOptions(investOptionRequest);
                    servicesAndRequest.updateServiceProductsMonthly = investOptionRequest;
                }


            }
            else
                dispatch(setSaveMonthlyPerformanceInvestmentOptions(false))
        }
        else{
            //call DELETE service-status service for Monthly Performance
            const reqObj = {
                "serviceOptionCode": monthlyPerformanceServiceOptionCode,
                "planNumber": planNumber,
            }
            if(!isCallFromSave){
                dispatch(setDeleteServiceCallForMonthlyPerformance(true))
                dispatch(setServiceStatusMonthlyPerformanceRequestData(reqObj))
                dispatch(setSaveMonthlyPerformancePreferences(true))
                dispatch(setSaveMonthlyPerformanceInvestmentOptions(false))
                dispatch(setPutServiceCallForMonthlyPerformance(false))
            }
            else{
                //dispatchDeleteDailyPricesOrMonthlyPerformance(reqObj);
                servicesAndRequest.deleteServiceStatusMonthly = reqObj;
            }


        }
    }

    const dispatchPreferencesAndSubscriptions = useCallback((serviceAndRequest) => {
        dispatch(savePreferencesAndSubscriptions({serviceAndRequest}))
    }, [dispatch]);

    const saveSubscriptionEmailAddress =  useCallback((updatedSubscriptionEmailAddress) => {
        dispatch(updateEmailAddress({emailAddress: updatedSubscriptionEmailAddress, planNumber}));
    }, [dispatch, subscriptionEmailAddress]);

    const showSignUpAgreementModal = useCallback(() => {
        dispatch(modalActions.showModal(modals.SIGN_UP_AGREEMENT_MODAL));
    },[dispatch]);

    const onClickSignUpTextAlerts = () => {
        if(!subscriptionEmailAddress.trim()) {
            setEmailSignUpTextAlertsError(true);
            setEditSubscriptionAndEmailNotOnFileError();
            emailAddressRef.current?.scrollIntoView({ behavior: "smooth" });
        } else{
            setEmailSignUpTextAlertsError(false);
            showSignUpAgreementModal();
        }
    };

    return (

        <StyledProfileInfo>
            { isOmniPlan &&
            <StyledTextSection>
                <StyledTextHeader>
                    Text
                </StyledTextHeader>
                <StyledTextContent>
                    When you sign up for text alerts, you will receive alerts related to your account activity and security. To stop receiving text alerts for a category below, you can switch the toggle to off, or reply STOP to an incoming alert for either category to unsubscribe from both categories. To unsubscribe from security text alerts, reply STOP to an incoming security alert.
                </StyledTextContent>
                <StyledTextAlertContent>
                    <StyledTextMobileContainer>
                        <StyledTextMobileLabel>
                            <StyledTextLabel>
                                Text alerts will be sent to the mobile number on file:
                            </StyledTextLabel>
                            { (mobileNumber && !isEditMobileMode) && <StyledPhoneNumber className="blocked_data">{mobileNumber}</StyledPhoneNumber>}
                            {isEditMobileMode ?
                                <StyledPhoneNumberContainer>
                                    <Input
                                        value={updatedMobileNumber}
                                        format="000-000-0000"
                                        formatType="pattern"
                                        placeholder="123-456-7890"
                                        onInput={handleMobileNumberChange}
                                        isPersonalInfo={false}
                                        isPrefAndSubPage={true}
                                    />
                                    <StyledPhoneButton>
                                        <Button
                                            variant="tertiary"
                                            buttonTitle="Save"
                                            disabled={!mobileNumberValid || isInternal()}
                                            onBeaconClick={() => saveMobileNumber(updatedMobileNumber)}/>
                                    </StyledPhoneButton>
                                </StyledPhoneNumberContainer> :
                                <>
                                    {!mobileNumber && <StyledValueContainer>
                                        <Button
                                            variant="tertiary"
                                            buttonTitle="Add Mobile Number"
                                            onBeaconClick={() => handleEditMobile()}/>
                                    </StyledValueContainer>
                                    }
                                </>
                            }
                        </StyledTextMobileLabel>
                        {(mobileNumber && !isEditMobileMode) &&
                            <StyledLinkContainer>
                                <Button
                                    variant="tertiary"
                                    isIcon={true}
                                    onBeaconClick={() => !isInternal() && handleEditMobile()}
                                    buttonTitle="Edit"
                                    disabled={isInternal()}/>
                            </StyledLinkContainer>}
                    </StyledTextMobileContainer>

                </StyledTextAlertContent>

                {!showSignUpForTextAlertsButton &&
                    <StyledSignUpButtonContainer>
                        <Button variant="secondary" isLink={true}  onBeaconClick={()=>onClickSignUpTextAlerts()} disabled={!mobileNumber || isEditMobileMode || isInternal()} buttonTitle="Sign Up for Text Alerts"/>
                    </StyledSignUpButtonContainer>
                }

                <StyledTextAlertsContainer>
                    <StyledTextAlertsHeader>
                        Text Alerts
                    </StyledTextAlertsHeader>
                    <StyledTextAlertsSubHeaderListContainer>
                        <StyledTextAlertsTitleContainer>
                            <Popover
                                id="profile-change-alerts"
                                popoverTitle="Profile Change Alerts"
                                popoverContent= "Profile change alerts will notify you about updates to your contact and beneficiary information."/>
                            <StyledValue >
                                {showSignUpForTextAlertsButton ?
                                        <ToggleSwitch
                                            checked={profileChangeAlerts}
                                            onChange={handleProfileChangeAlerts}
                                            name="profileChangeAlerts"
                                        />
                                :
                                "Off"}
                            </StyledValue>
                        </StyledTextAlertsTitleContainer>
                        <StyledTextAlertsTitleContainer>
                            <Popover
                                id="transactional-alerts"
                                popoverTitle="Transactional Alerts"
                                popoverContent= "Transactional alerts will notify you about certain transaction requests, such as  contribution changes and withdrawals."/>
                            <StyledValue >
                                {showSignUpForTextAlertsButton ? <ToggleSwitch
                                        checked={transactionAlerts}
                                        onChange={handleTransactionAlerts}
                                        name="transactionAlerts"
                                    />
                                    :
                                    "Off"}
                            </StyledValue>
                        </StyledTextAlertsTitleContainer>
                    </StyledTextAlertsSubHeaderListContainer>
                </StyledTextAlertsContainer>

            </StyledTextSection>
            }

            <StyledTextSection ref={emailAddressRef}>
                <StyledTextHeader>
                    Email
                </StyledTextHeader>
                <StyledTextContent>
                    Select your delivery preferences for plan documents and sign up for informative email subscriptions
                    below.
                </StyledTextContent>
                <StyledEmailAlertContent>
                    <StyledEmailLabel isEmailError={isEmailError || isEmailNotOnFileError}>
                        Emails will be sent to the email address on file:
                    </StyledEmailLabel>
                    {!isEditSubscriptionEmail && subscriptionEmailAddress && subscriptionEmailAddress.trim().length !== 0 ?
                        <StyledEmailContainer>
                            <StyledEmail className="blocked_data">{subscriptionEmailAddress}</StyledEmail>
                            <StyledEditButton>
                                <Button variant="tertiary" isIcon={true} onBeaconClick={() => !isInternal() && handleEditSubscriptionEmail()}
                                        buttonTitle="Edit" disabled={isInternal()}/>
                            </StyledEditButton>
                        </StyledEmailContainer>
                        :
                        isEditSubscriptionEmail ?
                            <StyledErrorContainer>
                                { (isEmailNotOnFileError && !emailSignUpTextAlertsError) && <ProfileBeaconError message={'Enter your email address to sign up.'}/> }
                                {emailSignUpTextAlertsError && <ProfileBeaconError message={'Enter your email address to sign up for text alerts.'}/> }
                            <StyledInputContainer>
                                <Input name="emailAddress" id="emailAddress"
                                       pattern={emailRegex} type="email" value={updatedSubscriptionEmail}
                                       onInput={handleSubscriptionEmailChange}
                                       onBlur={handleSubscriptionEmailValidation}
                                       isSubscriptionEmail={true}
                                       isEmailNotOnFileError={isEmailNotOnFileError}
                                       maxlength={80}
                                       errorsMap={{
                                           noMatchPattern: "Enter a valid email address.",
                                       }}
                                />
                                <StyledButton isEmailError={isEmailError}>
                                    <Button variant="tertiary" buttonTitle="Save"
                                            disabled={!isSubscriptionEmailValid || isInternal()} onBeaconClick={() => saveSubscriptionEmailAddress(updatedSubscriptionEmail)}/>
                                </StyledButton>
                            </StyledInputContainer>
                            </StyledErrorContainer>
                            :
                            <Button variant="tertiary" buttonTitle="Add Email Address" onBeaconClick={() => handleEditSubscriptionEmail()}/>
                    }
                </StyledEmailAlertContent>

                { isEmailUndeliverable &&
                    <StyledDisclaimerContainer>
                        <StyledDisclaimerHeader>
                            Update your email address
                        </StyledDisclaimerHeader>
                        <StyledDisclaimerContent>
                            We have not been able to deliver a message to your email address on file. Please update your email address.
                        </StyledDisclaimerContent>
                    </StyledDisclaimerContainer>
                }

            </StyledTextSection>
            <StyledTextSection>
                <StyledPaperLessOptionsContainer>
                    <StyledHeader>
                        Paperless Options
                    </StyledHeader>
                    <StyledTextContent>
                        Go paperless to receive email notifications as soon as your documents are ready to view online. It's quick, convenient, and secure!
                    </StyledTextContent>
                    <StyledTable>
                        <table>
                            <thead>
                            <tr>
                                <th className="headerLeft">
                                    <StyledTableHeader>
                                        RECORD TYPE
                                    </StyledTableHeader>
                                </th>
                                <th colSpan={2} className="headerCenter">
                                    <StyledTableHeader>
                                        DELIVERY METHOD
                                    </StyledTableHeader>
                                </th>
                            </tr>
                            </thead>
                            <tr>
                                <th>
                                </th>
                                <th className="header-center-with-border">
                                    <StyledTableHeader isSubHeader={true}>
                                        Paperless
                                    </StyledTableHeader>
                                </th>
                                <th>
                                    <StyledTableHeader isSubHeader={true}>
                                        U.S. Mail
                                    </StyledTableHeader>
                                </th>
                            </tr>
                            <tbody>
                            <tr className="no-bottom-border">
                                <td>
                                </td>
                                <td className="apply-border-td">
                                    <StyledColumnRecord>
                                        <StyledSelectButton><Button variant="tertiary" buttonTitle="Select All" onBeaconClick={handleSelectAllPaperlessOptions}/></StyledSelectButton>
                                    </StyledColumnRecord>
                                </td>
                                <td>
                                </td>
                            </tr>
                            {isShowStatements &&
                                <tr>
                                    <td className="align-data-left">
                                        <StyledColumnRecord>
                                            <Popover id="statements" popoverTitle="Statements"
                                                     popoverContent="Statements provide a quarterly summary of your account, including the value of each investment."/>
                                        </StyledColumnRecord>
                                    </td>
                                    <td className="apply-border-td">
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="1"
                                                name="statements"
                                                value="paperless"
                                                label="statements paperless"
                                                aria-checked={statementsPaperLess}
                                                checked={statementsPaperLess}
                                                onClick={()=>{onPreferencesRadioChange("5",true)}}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                    <td>
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="2"
                                                name="statements"
                                                value="USMail"
                                                label="statements US Mail"
                                                aria-checked={!statementsPaperLess}
                                                checked={!statementsPaperLess}
                                                onClick={()=>{ onPreferencesRadioChange("5",false)}}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                </tr>
                            }
                            {showEConfirm &&
                                <tr>
                                    <td className="align-data-left">
                                        <StyledColumnRecord>
                                            <Popover id="confirmations"
                                                     popoverTitle="Confirmations & Prospectuses (If Applicable)"
                                                     popoverContent="Confirmations verify account activity and prospectuses provide investment details. Currently, only 403(b) Plan - Individual Custodial Account participants receive prospectuses upon initial investment."/>
                                        </StyledColumnRecord>
                                    </td>
                                    <td className="apply-border-td">
                                        <StyledColumnRecord>
                                                   <StyledRadioButton
                                                    id="3"
                                                    name="confirmations"
                                                    value="paperless"
                                                    label="confirmations paperless"
                                                    aria-checked={confirmationsPaperless}
                                                    checked={confirmationsPaperless}
                                                    onClick={() => onPreferencesRadioChange("28", true)}
                                                />
                                        </StyledColumnRecord>
                                    </td>
                                    <td>
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="4"
                                                name="confirmations"
                                                value="USMail"
                                                label="confirmations US Mail"
                                                aria-checked={!confirmationsPaperless}
                                                checked={!confirmationsPaperless}
                                                onClick={() => onPreferencesRadioChange("28",false)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                </tr>
                            }
                            {paperlessPlanFeeDisclosures &&
                                <tr>
                                    <td className="align-data-left">
                                        <StyledColumnRecord>
                                            <Popover id="disclosures"
                                                     popoverContent="Disclosures may provide (but are not limited to) details about your plan and its investment options (including any default investments), fees, annual performance, and notifications of temporary “blackout” periods (during which investments and/or distributions are restricted)."
                                                     popoverTitle="Disclosures"
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                    <td className="apply-border-td">
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="5"
                                                name="disclosures"
                                                value="paperless"
                                                label="disclosures paperless"
                                                aria-checked={disclosuresPaperless}
                                                checked={disclosuresPaperless}
                                                onClick={() => onPreferencesRadioChange("33",true)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                    <td>
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="6"
                                                name="disclosures"
                                                value="USMail"
                                                label="disclosures US Mail"
                                                aria-checked={!disclosuresPaperless}
                                                checked={!disclosuresPaperless}
                                                onClick={() => onPreferencesRadioChange("33",false)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                </tr>
                            }
                            {paperlessPlanLegalNotices &&
                                <tr>
                                    <td className="align-data-left">
                                        <StyledColumnRecord>
                                            <Popover id="notices"
                                                     popoverTitle="Notices"
                                                     popoverContent="Notices may provide (but are not limited to) details about your plan’s auto-enrollment and/or safe harbor contributions (if applicable), withdrawal and vesting provisions, and rollover options."/>
                                        </StyledColumnRecord>
                                    </td>
                                    <td className="apply-border-td">
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="7"
                                                name="notices"
                                                value="paperless"
                                                label="notices paperless"
                                                aria-checked={noticesPaperless}
                                                checked={noticesPaperless}
                                                onClick={() => onPreferencesRadioChange("35",true)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                    <td>
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="8"
                                                name="notices"
                                                value="USMail"
                                                label="notices US Mail"
                                                aria-checked={!noticesPaperless}
                                                checked={!noticesPaperless}
                                                onClick={() => onPreferencesRadioChange("35",false)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                </tr>
                            }
                            {showProxyNotices &&
                                <tr>
                                    <td className="align-data-left">
                                        <StyledColumnRecord>
                                            <Popover id="proxyNotices" popoverTitle=" Proxy Notices (Employer stock)"
                                                     popoverContent="Proxy notices provide voting information for shares of any employer stock in your account. These notices will be sent from your employer’s proxy tabulator."/>
                                        </StyledColumnRecord>
                                    </td>
                                    <td className="apply-border-td">
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="9"
                                                name="proxy"
                                                value="paperless"
                                                label="proxy paperless"
                                                aria-checked={proxyPaperless}
                                                checked={proxyPaperless}
                                                onClick={() => onPreferencesRadioChange("34",true)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                    <td>
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="10"
                                                name="proxy"
                                                value="USMail"
                                                label="proxy US Mail"
                                                aria-checked={!proxyPaperless}
                                                checked={!proxyPaperless}
                                                onClick={() => onPreferencesRadioChange("34",false)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                </tr>
                            }
                            {showSempraActiveDeliveryOptionLabel &&
                                <tr>
                                    <td className="align-data-left">
                                        <StyledColumnRecord>
                                            <Popover id="sempraActive" popoverTitle= {sempraActiveDeliveryOptionLabel}
                                                     popoverContent={sempraDeliveryOptionsPopOver}/>
                                        </StyledColumnRecord>
                                    </td>
                                    <td className="apply-border-td">
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="11"
                                                name={sempraActiveDeliveryOptionLabel}
                                                value="paperless"
                                                label="sempra paperless"
                                                aria-checked={prospectusAndFormsEmployedPaperless}
                                                checked={prospectusAndFormsEmployedPaperless}
                                                onClick={() => onPreferencesRadioChange("57",true)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                    <td>
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="12"
                                                name={sempraActiveDeliveryOptionLabel}
                                                value="USMail"
                                                label="sempra US Mail"
                                                aria-checked={!prospectusAndFormsEmployedPaperless}
                                                checked={!prospectusAndFormsEmployedPaperless}
                                                onClick={() => onPreferencesRadioChange("57",false)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                </tr>
                            }
                            {showSempraTerminatedDeliveryOptionLabel &&
                                <tr>
                                    <td className="align-data-left">
                                        <StyledColumnRecord>
                                            <Popover id="sempraTerminated" popoverTitle={sempraTerminatedDeliveryOptionLabel}
                                                     popoverContent={sempraDeliveryOptionsPopOver}/>
                                        </StyledColumnRecord>
                                    </td>
                                    <td className="apply-border-td">
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="13"
                                                name={sempraTerminatedDeliveryOptionLabel}
                                                value="paperless"
                                                label="sempra paperless"
                                                aria-checked={prospectusAndFormsAfterEmploymentPaperless}
                                                checked={prospectusAndFormsAfterEmploymentPaperless}
                                                onClick={() => onPreferencesRadioChange("58",true)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                    <td>
                                        <StyledColumnRecord>
                                            <StyledRadioButton
                                                id="14"
                                                name={sempraTerminatedDeliveryOptionLabel}
                                                value="USMail"
                                                label="sempra US Mail"
                                                aria-checked={!prospectusAndFormsAfterEmploymentPaperless}
                                                checked={!prospectusAndFormsAfterEmploymentPaperless}
                                                onClick={() => onPreferencesRadioChange("58",false)}
                                            />
                                        </StyledColumnRecord>
                                    </td>
                                </tr>
                            }
                            </tbody>
                        </table>
                    </StyledTable>
                </StyledPaperLessOptionsContainer>
            </StyledTextSection>
            <StyledTextSection>
                <StyledHeader>
                    Email Subscriptions
                </StyledHeader>
                <StyledSubscriptionContent>
                    Sign up to receive helpful information about your plan and your investments. Staying well informed
                    can help you manage your account and better prepare you for retirement.
                </StyledSubscriptionContent>
                <StyledCheckboxContainer>
                    <StyledCheckbox
                        label="Tips & Resources"
                        id="checkbox-1"
                        name="tipsAndResources"
                        value={tipsAndResourceStatus}
                        checked={tipsAndResourceStatus}
                        onInput={(event: any) => onEmailSubscriptionChange(event,"25")}
                    />
                    <StyledCheckboxDescription>
                        Learn more about helpful products and services, receive the latest news and developments from
                        T. Rowe Price, and stay informed on the latest tools and resources available to help you plan for the future.
                    </StyledCheckboxDescription>
                </StyledCheckboxContainer>
                <StyledCheckboxContainer>
                    <StyledCheckbox
                        label="Daily Prices"
                        id="checkbox-2"
                        name="dailyPrices"
                        value={dailyPricesStatus}
                        checked={dailyPricesStatus}
                        onInput={(event: any) => onEmailSubscriptionChange(event,"23")}
                    />
                    <StyledCheckboxDescription>
                        In this daily email, you will receive closing daily prices for your personalized list of
                        investments in your plan. Please note that you will receive one email regardless of the number of investments you have selected.
                        { isDailyPricesInvestmentError &&
                        <StyledDisclaimerContainer isInvestmentError={true}>
                            <StyledDisclaimerContent isInvestmentError={true}>
                                You need to select at least one investment for this subscription option.
                            </StyledDisclaimerContent>
                        </StyledDisclaimerContainer>}
                        { dailyPricesStatus &&
                        <StyledDropdownContainer>
                            <Dropdown name="dailyPrices" id="drop-down-1" value={updatedDailyPriceInvOption}
                                      options={investmentOptions} onInput={handleDailyPricesChange}
                            />
                            {showUpdateInvestmentsDailyPrices ? <StyledUpdateInvestmentButton>
                                    <Button variant="tertiary" isIcon={true}  buttonTitle="Update Investments" onBeaconClick={dispatchDailyPricesInvestmentOptionsModal}/>
                                </StyledUpdateInvestmentButton> :
                                ''}
                        </StyledDropdownContainer>
                        }
                    </StyledCheckboxDescription>
                </StyledCheckboxContainer>
                <StyledCheckboxContainer>
                    <StyledCheckbox
                        label="Monthly Performance"
                        id="checkbox-3"
                        name="monthlyPerformance"
                        value={monthlyPerformancesStatus}
                        checked={monthlyPerformancesStatus}
                        onInput={(event: any) => onEmailSubscriptionChange(event,"24")}
                    />
                    <StyledCheckboxDescription>
                        In this monthly email, you will receive monthly performance information for your
                        personalized list of investments in your plan. Please note that you will receive one email regardless of the number investments you have selected.
                        {isMonthlyPerformanceInvestmentError &&
                            <StyledDisclaimerContainer isInvestmentError={true}>
                                <StyledDisclaimerContent isInvestmentError={true}>
                                    You need to select at least one investment for this subscription option.
                                </StyledDisclaimerContent>
                            </StyledDisclaimerContainer>}
                        { monthlyPerformancesStatus &&
                        <StyledDropdownContainer>
                            <Dropdown name="monthlyPerformance" id="drop-down-2" value={updatedMonthlyPerformanceOption}
                                      options={investmentOptions} onInput={handleMonthlyPerformanceChange}
                            />
                            {showUpdateInvestmentsMonthlyPerformance? <StyledUpdateInvestmentButton>
                                    <Button variant="tertiary" isIcon={true}  buttonTitle="Update Investments" onBeaconClick={dispatchMonthlyPerformanceInvestmentModal}/>
                                </StyledUpdateInvestmentButton> :
                                ''}
                        </StyledDropdownContainer>
                        }
                    </StyledCheckboxDescription>
                </StyledCheckboxContainer>
                <StyledCheckboxContainer>
                    <StyledCheckbox
                        label="Withdrawals"
                        id="checkbox-4"
                        name="withdrawals"
                        value={withdrawalsStatus}
                        checked={withdrawalsStatus}
                        onInput={(event: any) => onEmailSubscriptionChange(event,"30")}

                    />
                    <StyledCheckboxDescription>
                        Receive an email alert on the status of your withdrawal.
                    </StyledCheckboxDescription>
                </StyledCheckboxContainer>
                <StyledButtonContainer>
                    <StyledLinkButton>
                        <Button variant="tertiary" onBeaconClick={()=>{isUserChangedValues ? showConfirmSaveModal() : cancelPreferences()}} isLink={true} buttonTitle="Cancel"/>
                    </StyledLinkButton>
                    <Button onBeaconClick={validatePreferencesAndSubscription} disabled={!isSaveButtonEnabled || isInternal()} buttonTitle="Save"/>
                </StyledButtonContainer>
            </StyledTextSection>
        </StyledProfileInfo>

    );
};
